export default __webpack_public_path__ + "static/media/jeweled_jungle.916a03a8.svg";